<template>
    <div id="Stats">
        <div class="box" id="title">
            <h1 class="title has-text-grey-dark"><i class="fa fa-chart-line"></i> Your  Achievements</h1>
            <p class="subtitle">See how much time you saved using the Feedback Assistant</p>
        </div>
        <!--<hr>-->
        <clip-loader v-if="loading"></clip-loader>
        <div class="box" v-else>
            <div class="columns is-multiline" v-if="!loading">
                <div class="column is-4 is-offset-2">
                    <div class="box notification is-info">
                        <div class="heading">Became member</div>
                        <div class="title">{{stats.active}}</div>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="box notification is-danger">
                        <div class="heading">Saved time</div>
                        <div class="title"><i class="fa fa-clock-o"></i> ~{{stats.saved_time}}</div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline" v-if="!loading">
                <div class="column">
                    <div class="box notification is-primary">
                        <div class="title"><i class="fa fa-coffee"></i> Feedback</div>
                        <div class="level">
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Generated</div>
                                    <div class="title is-1 has-text-centered">{{stats.generated_comments}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="level">
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Unique</div>
                                    <div class="title is-3 has-text-centered">{{stats.unique_comments}}</div>
                                </div>
                            </div>
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Custom</div>
                                    <div class="title is-3 has-text-centered">{{stats.manually_generated_comments}}</div>
                                </div>
                            </div>
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Unique custom</div>
                                    <div class="title is-3 has-text-centered">{{stats.manually_unique_comments}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="box notification is-warning">
                        <div class="title"> <i class="fa fa-pencil"></i> Sentences</div>
                        <div class="level">
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Used</div>
                                    <div class="title is-1 has-text-centered">{{stats.used_sentences}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="level">
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Unique</div>
                                    <div class="title is-3 has-text-centered">{{stats.unique_sentences}}</div>
                                </div>
                            </div>
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Custom used</div>
                                    <div class="title is-3 has-text-centered">{{stats.used_manually_created_sentences}}</div>
                                </div>
                            </div>
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Custom unique</div>
                                    <div class="title is-3 has-text-centered">{{stats.manually_created_sentences}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline" v-if="!loading">
                <div class="column">
                    <div class="box notification is-black">
                        <div class="title"><i class="fa fa-graduation-cap"></i> Students</div>
                        <div class="level">
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Total feedbacks given</div>
                                    <div class="title is-1 has-text-centered">{{stats.students}}</div>
                                </div>
                            </div>
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Unique</div>
                                    <div class="title is-1 has-text-centered">{{stats.unique_students}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="box notification is-success">
                        <div class="title"> <i class="fa fa-book"></i> Lessons</div>
                        <div class="level">
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Total</div>
                                    <div class="title is-1 has-text-centered">{{stats.lessons}}</div>
                                </div>
                            </div>
                            <div class="level-item">
                                <div class="">
                                    <div class="heading has-text-centered">Unique</div>
                                    <div class="title is-1 has-text-centered">{{stats.unique_lessons}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline" v-if="!loading">
                <div class="column">
                    <p class="title is-3 has-text-warning"><i class="fa fa-pencil"></i> Favorite sentences</p>
                    <hr>
                    <div class="columns is-multiline">
                        <div class="column is-12 minimal-vertical-padding minimal-vertical-margin" v-for='(sentence, index) in stats.top_sentences' v-if="stats.top_sentences && stats.top_sentences.length > 0">
                            <div class="card clickable minimal-vertical-padding minimal-vertical-margin">
                                <div class="card-content minimal-vertical-padding minimal-vertical-margin">
                                    <h4 class="has-text-grey-dark is-size-6 multiline-text" ><b>{{index + 1}}.</b> {{sentence.text}} <b>({{sentence.count > 1 ? sentence.count + " times used" : sentence.count + " time used"}})</b></h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <p class="title is-3 has-text-black"><i class="fa fa-graduation-cap"></i> Favorite students</p>
                    <hr>
                    <div class="columns is-multiline">
                        <div class="column is-12" v-for="(student, index) in stats.top_students" v-if="stats.top_students && stats.top_students.length > 0">
                            <div class="card is-info clickable mb10">
                                <div class="card-content">

                                    <div class="media">
                                        <div class="media-left">
                                            <figure class="image is-48x48">
                                                <i class="fa fa-user fa-4x has-text-black"></i>
                                            </figure>
                                        </div>
                                        <div class="media-content">
                                            <p class="title is-4">{{student.name}} <i class="fa fa-mars has-text-info" v-if="student.gender == 'male'"></i><i class="fa fa-venus has-text-danger" v-else></i></p>
                                            <p class="subtitle is-6" v-if="student.nick">@{{student.nick}}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="column is-12" v-if="!stats.top_students || stats.top_students.length == 0">
                            <div class="notification is-danger has-text-centered">
                                You don't have any favorite students, go to <router-link to="/dashboard/comments"><b>Feedback</b></router-link> page and generate some feedback!
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <p class="title is-3 has-text-success"><i class="fa fa-book"></i> Favorite lessons</p>
                    <hr>
                    <div class="columns is-multiline">
                        <div class="column is-12" v-for="(lesson, index) in stats.top_lessons" v-if="stats.top_lessons && stats.top_lessons.length > 0">
                            <div class="card is-info clickable mb10">
                                <div class="card-content">

                                    <div class="media">
                                        <div class="media-left">
                                            <figure class="image is-48x48">
                                                <i class="fa fa-book has-text-success fa-3x"></i>
                                            </figure>
                                        </div>
                                        <div class="media-content">
                                            <p class="title is-4">{{lesson.name}}</p>
                                            <p class="subtitle is-6">{{lesson.words}}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="column is-12" v-if="!stats.top_lessons || stats.top_lessons.length == 0">
                            <div class="notification is-danger has-text-centered">
                                You don't have any favorite lessons, go to <router-link to="/dashboard/comments"><b>Feedback</b></router-link> page and generate some feedback!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline" v-if="!loading">
                <div class="column">
                    <p class="title is-3 has-text-primary"><i class="fa fa-coffee"></i> Favorite feedback</p>
                    <hr>
                    <div class="columns is-multiline">
                        <div class="column is-8 is-offset-2" v-for="(comment, index) in stats.top_comments" v-if="stats.top_comments && stats.top_comments.length > 0">
                            <div class="card clickable">
                                <header class="card-header min-height-100" v-if="comment.favorite == 1">
                                    <p class="card-header-title">{{comment.caption}} ({{comment.count > 1 ? comment.count + " times used" : comment.count + " time used"}})</p>
                                    <a class="card-header-icon">
                                        <star-rating inactive-color="#ababab" :star-size="20" :show-rating="false" :read-only="true" :rating="comment.score"></star-rating>
                                    </a>
                                </header>
                                <header class="card-header" v-else>
                                    <p class="card-header-title">{{comment.created_at}} ({{comment.count > 1 ? comment.count + " times used" : comment.count + " time used"}})</p>
                                    <a class="card-header-icon">
                                              <span class="icon">
                                                <i class="fa fa-history" aria-hidden="true"></i>
                                              </span>
                                    </a>
                                </header>
                                <div class="card-content max-height-250">
                                    <div class="content has-text-justified">
                                        <p class="has-text-grey-dark">{{comment.text}}</p>
                                        <time  class="has-text-grey-dark">{{comment.created_at}}</time>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column is-12" v-if="!stats.top_comments || stats.top_comments.length == 0">
                            <div class="notification is-danger has-text-centered">
                                You don't have any favorite feedback, go to <router-link to="/dashboard/comments"><b>Feedback</b></router-link> page and generate some!
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>

import Vue from 'vue'
import UserRepo from '../repos/UserRepo'
import VueAvatar from '../components/util/VueAvatar'
import Form from '../utils/Form';
import _ from 'lodash'
import StarRating from 'vue-star-rating'

export default {
  name: 'stats',
  components: {StarRating},
  data() {
        return {
            loading: false,
            saving: false,
            repo: new UserRepo(this.$auth),
            stats: {}
        }
  },
  created(){    
  },
  mounted(){
    this.getStats();

  },
  methods: {

      start(){

      },
      getStats(){
        this.loading = true;
        this.repo.stats().then((response) => {
            this.stats = response.data.data;

            //console.log(response.data.data);

        }).finally(() => {
            this.loading = false;

        });
      }

     
  },  
  watch: {
  }
  
}
</script>

<style lang="css" scoped>

    .min-height-100{
        min-height: 100px;
        height: fit-content;
    }

</style>



// WEBPACK FOOTER //
// src/pages/Stats.vue